import PropTypes from 'prop-types';
import React, {useRef,useEffect} from 'react';
import './CustomSearchBox.css';


const CustomSearchBoxFieldType = {
    inputFieldId: PropTypes.string.isRequired,
    isRequired: PropTypes.bool.isRequired,
    inputName: PropTypes.string,
    className: PropTypes.string,
    inputPlaceHolder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null]),
    ]),
    inputValue: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    handleInputChange: PropTypes.func,
    isResizeable: PropTypes.bool,
    errorMessage: PropTypes.string,
    maxHeight:PropTypes.number.isRequired,
    enterToSubmit:PropTypes.bool,
    handleSearchBoxFocused: PropTypes.func
  };

  
export type CustomSearchBoxFieldPropTypes = PropTypes.InferProps<typeof CustomSearchBoxFieldType>;

const CustomSearchBox : React.FC<CustomSearchBoxFieldPropTypes> = (props) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);


    const resizeTextArea = () => {
    const el = textAreaRef.current;
    if (!el) return;
    el.style.height = 'auto'; // reset height
    el.style.height = Math.min(el.scrollHeight, props.maxHeight) + 'px';
  };

  useEffect(() => {
    resizeTextArea();
  }, [props.inputValue]); 

  const keyDownHandler = (e)=>{
    if(e.key==='Enter' && !e.shiftKey){
      e.preventDefault();
    }
    
  }

  return(
    <>
      <textarea style ={{ resize: props.isResizeable ? 'both' : 'none',border:'none' }} disabled={props?.isDisabled ?? false} id="w3review" name="w3review" className={'rms__custom__search__area ' + props.className}  value={props.inputValue} placeholder={props?.inputPlaceHolder ?? ''} onChange={(e) => props?.handleInputChange?.(e)}
        ref={textAreaRef}
        onKeyDown={props.enterToSubmit!==undefined && props.enterToSubmit ? keyDownHandler : ()=>{}}
        onFocus={props?.handleSearchBoxFocused ? props?.handleSearchBoxFocused : (event)=>{event?.preventDefault();event?.stopPropagation();}}
        ></textarea>
    {props?.errorMessage && props?.errorMessage?.length > 0 && <div className="rms__custom__input__error__message">
      {props?.errorMessage}
    </div>}
    </>
  )
}

export default CustomSearchBox;

